// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"Z_-z","disabled":"__-z","label":"aaa-z"};